<template>
    <div>
        <!---
        You can use the `control` object - basically, it's main data of your custom control field
        --->

        <div :class="styles.FORM.FORM_GROUP">
            <label>
                Min Width
            </label>
            <input type="text"
                   :class="styles.FORM.FORM_CONTROL"
                   v-model="control.minWidth"
            >
        </div>

        <div :class="styles.FORM.FORM_GROUP">
            <label>
                Max Width
            </label>
            <input type="text"
                   :class="styles.FORM.FORM_CONTROL"
                   v-model="control.maxWidth"
            >
        </div>

        <div :class="styles.FORM.FORM_GROUP">
            <label>
                Background Color
            </label>
            <input type="text"
                   :class="styles.FORM.FORM_CONTROL"
                   v-model="control.backgroundColor"
            >
        </div>
    </div>
</template>

<script>
    import BaseControlConfigSkeleton from "../../skeletons/controls/BaseControlConfigSkeleton";

    export default {
        name: "SignatureConfigView",
        extends: BaseControlConfigSkeleton,
    }
</script>